module.exports = __webpack_public_path__ + "static/media/cd2-icon-financial-exposure.716113ab.svg";